
import { defineComponent, PropType, computed } from 'vue';
import { IBienBanGiaiTheResponseBase } from '@/core/interfaces/ApiResponses';
import { useBienBanConfirmApprove } from '@/core/hooks/use-bien-ban-confirm-approve';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import usePermission from '@/core/hooks/usePermission';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ConfirmationApproveDialog from '@/components/confirmation-approve-dialog/ConfirmationApproveDialog.vue';
import PageHeaderActionItem from '@/layout/header/PageHeaderActionItem.vue';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';

export default defineComponent({
  name: 'BienBanConfirmButton',

  components: {
    ButtonCustom,
    ConfirmationApproveDialog,
    PageHeaderActionItem,
  },

  props: {
    bienBan: {
      type: Object as PropType<IBienBanGiaiTheResponseBase | null>,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
    asMenuItem: {
      type: Boolean,
      default: false,
    },
    onSuccess: {
      type: Function as PropType<() => void | Promise<void>>,
      default: undefined,
    },
  },

  setup(props) {
    const { ButtonTypeColors, ButtonsType } = useButtonCustom();
    const { canConfirmBbgt } = usePermission();

    const {
      showConfirmDialog,
      openConfirmDialog: openDialog,
      closeConfirmDialog,
      handleConfirm: handleConfirmAction,
    } = useBienBanConfirmApprove(props.onSuccess);

    const openConfirmDialog = () => {
      if (props.bienBan) {
        openDialog(props.bienBan);
      }
    };

    const handleConfirm = async () => {
      await handleConfirmAction();
    };

    const computedTooltipMessage = computed(() => {
      if (props.tooltipMessage) {
        return props.tooltipMessage;
      }

      if (!props.bienBan) {
        return '';
      }

      if (!canConfirmBbgt.value) {
        return 'Không có quyền';
      }

      if (props.bienBan.is_approved) {
        return 'Kỹ thuật đã xác nhận';
      }

      return 'Kỹ thuật xác nhận';
    });

    const computedIsDisabled = computed(() => {
      if (props.isDisabled) {
        return true;
      }

      if (!props.bienBan) {
        return true;
      }

      return props.bienBan.is_approved || !canConfirmBbgt.value;
    });

    return {
      ButtonTypeColors,
      ButtonsType,
      showConfirmDialog,
      openConfirmDialog,
      closeConfirmDialog,
      handleConfirm,
      computedTooltipMessage,
      computedIsDisabled,
      faCheckDouble,
    };
  },
});
